import { getUsersProfile } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const USER_PROFILE = "USER_PROFILE";

export function useUserProfile() {
	return useQuery({
		queryKey: [USER_PROFILE],
		queryFn: processResponse(() => getUsersProfile()),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}

export function useUser() {
	const { data: user, isLoading } = useUserProfile();

	return { user, isLoading };
}
